module.exports = __webpack_public_path__ + "static/img/logo.567c9b3a.png";